/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useRef} from 'react';
import {useDispatch} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {JobStatus} from '@ion/core/src/types/entities';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {CellMenu} from '@ion/dls/src/components/grid/CellMenu';
import {CellMenuItem} from '@ion/dls/src/components/grid/CellMenuItem';
import {
  ViewRecordIcon
} from '@ion/dls/src/icons/ViewRecordIcon';
import {showJobStatus} from './state';

// defines the device row editor prop definitions ...
export interface JobStatusRowEditorTypes {
  jobstatus: JobStatus;
  selectedJobId?: Function;
}

/**
 * Defines the JobStatusRowEditor component. This component contains the cell actions
 * for Job Status grid.
 */
export const JobStatusRowEditor = ({jobstatus, selectedJobId}: JobStatusRowEditorTypes) => {
  const dispatch    = useDispatch();
  const cellMenuRef = useRef(null);

  function closeMenu() {
    cellMenuRef.current.closeCellMenu(cellMenuRef.current, true);
  };

  function deleteJobStatus() {
    dispatch(showJobStatus(jobstatus, true));
    closeMenu();
  };

  function viewJobStatus() {
    const {response} = safeJSONParse(jobstatus?.info?.response?.body) || {};
    if (response?.results?.jobId && selectedJobId) {
      selectedJobId?.(response?.results?.jobId);
    } else {
      dispatch(showJobStatus(jobstatus, true));
    }
    closeMenu();
  };

  return (
    <>
      <CellMenu ref={cellMenuRef} menuItems={
        <div>
          <CellMenuItem icon={<ViewRecordIcon />}
            onClick={viewJobStatus}
            label={translate('jobstatus:grid.menu.viewJobStatus')} />
        </div>
      } />
    </>
  );
};
export default JobStatusRowEditor;
